'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = errorMiddleware;

var _utils = require('helpers/utils');

var _constants = require('redux/constants');

var _auth = require('redux/actions/auth');

var _errors = require('api/errors.constants');

function errorMiddleware() {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        var _getState = getState(),
            lang = _getState.lang;

        return function (next) {
            return function (action) {
                if (action.type === 'error') {
                    return next(action);
                } else if (action.show_error) {

                    if (action.hasOwnProperty('show_404') && action.show_404 === true) {
                        return next(action);
                    }

                    var _ref2 = action.error || {},
                        code = _ref2.code;

                    if (Number(code) !== 0) {
                        code = parseInt(code, 10) || null;
                    } else {
                        code = Number(code);
                    }

                    // это решение принудительное, так как ошибка авторизации моежт быть в любом из заданных пунктов.
                    if (code === _errors.ERROR_CODE_INVALID_ACCESS_TOKEN) {
                        action.error.message = lang['store.error_middleware.auth_error'];
                    }

                    // Подавляем ошибку refresh_token.
                    if (code === _errors.ERROR_CODE_INVALID_REFRESH_TOKEN) {
                        action.show_error = false; // подавляем ошибку
                        action.server_not_found = false;
                        dispatch((0, _auth.refreshLogout)());
                        return next(action);
                    }

                    //Подавление ошибки для неправильной категории или товаре
                    if (action.error.code === 139) {
                        //error.title === 'humanFriendlyException.doesNotExistCategory'
                        action.show_error = false;
                        return next(action);
                    }

                    //Подавление ошибки при наличии алкоголя в корзине
                    if (action.error.code === 136) {
                        //error.title === 'error.orderExciseMarkBarcodeIsRequired'
                        action.show_error = false;
                        return next(action);
                    }

                    switch (action.type) {
                        case _constants.AuthConstants.LOGIN_FAIL:
                        case _constants.PaymentConstants.PAY_INNER_PIPO_FAIL:
                        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL:
                        case _constants.RegistrationConstants.REGISTRATION_FORM_FAIL:
                        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL:
                        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL:
                        case _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL:
                        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL:
                        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL:
                        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL:
                        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL:
                        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL:
                        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
                        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL:
                        case _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL:
                        case _constants.Personal.OrderList.ORDER_SETTING_FAIL: //подавление ошибки при редиректе в фаерфоксе
                        case _constants.SliderConstants.SLIDER_LOAD_FAIL:
                            if (!action.error.message) {
                                action.error.message = (0, _utils.replaceCharToArrayIndex)(lang[action.error.title], action.error.dataError);
                            }

                            action.show_error = false; // подавляем ошибку, ошибка будет выводится в самом окне авторизации или регистрации
                            return next(action);
                    }

                    switch (code) {
                        case null:
                            action.server_not_found = true;
                            action.show_error = false;
                            break;
                        case _errors.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL:
                            action.server_not_found = false;
                            action.show_error = false;
                            break;
                        case _errors.ERROR_CODE_INVALID_ACCESS_TOKEN:
                            next((0, _auth.resetAuth)()); // сбрасываем пользователя
                            action.error.message = (0, _utils.replaceCharToArrayIndex)(lang['store.error_middleware.auth_error']);
                            break;
                        case _errors.ERROR_CODE_TARIFF:
                        case _errors.ERROR_CODE_GENERAL_ERROR:
                            action.error.message = (0, _utils.replaceCharToArrayIndex)(lang['store.error_middleware.general_error']);
                            break;
                        case _errors.ERROR_FEW_PRODUCTS:
                            action.show_error = false;
                            break;
                        case _errors.ERROR_UNKNOWN_ERROR:
                            break;
                        default:
                            action.error.message = lang['store.error_middleware.error'] + ': ' + lang[action.error.title];
                            break;
                    }
                }

                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/errorMiddleware.js
// module id = 1888
// module chunks = 0